import {FaTrash} from "react-icons/fa";
import {FaPencil} from "react-icons/fa6";
import {getUrl} from "../../../constants/urls";

export const customFieldsListUrl = getUrl("customFields");

export const ACTIONS_LIST = [
  {label: "Edit", icon: FaPencil, perms: ["change_customfield"]},
  {label: "Delete", icon: FaTrash, perms: ["delete_customfield"]},
];

export const PERMS_FOR_ACTIONS = ["change_customfield", "delete_customfield"];

export const LIST_HEADERS = [
  "name",
  "label",
  "object_types",
  "type",
  "is_required",
  "is_unique",
  "description",
];

export const CUSTOM_RENDER_KEYS = ["object_types", "type"];
